import axios from 'axios'

// let IS_PROD = true

export var IS_PROD = true
// IS_PROD = false

const regionMap = {
  OLD: 'https://registry.siyouyun.cc',
  CN: 'https://registry-cn.siyouyun.cc',
  SEA: 'https://registry-sea.naspntc.com',
  EU: 'https://registry-eu.naspntc.com',
  'US-WEST': 'https://registry-us-west.naspntc.com',
  'US-EAST': 'https://registry-us-east.naspntc.com'
}

export var getRegistryUrl = (region) => IS_PROD ? regionMap[region] : 'https://registry.pntc.siyouyun.cc'
export let baseURL = ''
export let currentLocale = ''

const instance = axios.create()

instance.defaults.headers.post['Content-Type'] = 'application/json'

// 请求拦截器
instance.interceptors.request.use(function (config) {
  config.baseURL = baseURL
  if (currentLocale) {
    config.headers['Accept-Language'] = currentLocale
  }
  return config
}, function (error) {
  return Promise.reject(error)
})

// 响应拦截器
instance.interceptors.response.use(function (response) {
  if (response.status >= 200 && response.status < 400) {
    return response.data
  } else {
    throw new Error('network_error')
  }
}, function (error) {
  return Promise.reject(error)
})

export function setBaseUrl (url) {
  baseURL = url
}

export function setEnv (isProd) {
  IS_PROD = isProd
}

export function setLocale (locale) {
  currentLocale = locale
}

export default instance
